import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTE } from '@portal/data-access';
import { tap } from 'rxjs';
import { PortalVerificationStore } from '../store';

export const verifiedGuard = () => {
  const router = inject(Router);
  const store = inject(PortalVerificationStore);

  return store.isVerified$.pipe(
    tap(isVerified => {
      return !isVerified ? router.navigate([ROUTE.VERIFICATION.MAIN]) : true;
    }),
  );
};
